import { useState } from "react";
import { SparklesIcon } from "@heroicons/react/24/solid";
import { cn } from "../../services/Utils";

const COMPETITOR_LOGO_BASE = "/assets/competitors";

/**
 * Drop real logo files at `public/assets/competitors/<file>` to replace the
 * monogram placeholders below — each logo falls back on its own if missing.
 */
const COMPETITORS = [
  { name: "customer.io", src: `${COMPETITOR_LOGO_BASE}/customerio.svg` },
  { name: "Mailchimp", src: `${COMPETITOR_LOGO_BASE}/mailchimp.svg` },
  { name: "Iterable", src: `${COMPETITOR_LOGO_BASE}/iterable.svg` },
  { name: "Ortto", src: `${COMPETITOR_LOGO_BASE}/ortto.svg` },
];

function CompetitorLogo({ name, src }) {
  const [hasImage, setHasImage] = useState(true);

  return (
    <div className="flex w-20 shrink-0 flex-col items-center gap-2 text-center">
      {hasImage ? (
        <img
          src={src}
          alt=""
          onError={() => setHasImage(false)}
          className="h-9 w-auto max-w-full object-contain"
        />
      ) : (
        <span
          aria-hidden="true"
          className="flex h-9 w-9 items-center justify-center rounded-xl border border-neutral-200 bg-neutral-50 text-sm font-semibold text-neutral-400"
        >
          {name.charAt(0).toUpperCase()}
        </span>
      )}
      <span className="text-[13px] font-medium tracking-tight text-neutral-500">
        {name}
      </span>
    </div>
  );
}

export default function MigrationBanner({ className }) {
  return (
    <div
      className={cn(
        "relative z-20 mx-auto w-full max-w-7xl px-4 pt-16 md:pt-24 lg:px-12",
        className,
      )}
    >
      <div className="flex flex-col items-center gap-8 rounded-3xl border border-neutral-200/80 bg-white/80 px-6 py-8 shadow-sm md:px-10 lg:flex-row lg:justify-between lg:gap-12">
        <div className="flex flex-col items-center gap-5 text-center sm:flex-row sm:items-start sm:text-left">
          <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-primary/10">
            <SparklesIcon className="h-7 w-7 text-primary" />
          </span>
          <div>
            <h2 className="max-w-sm text-lg font-semibold text-gray-800 md:text-xl">
              Built for teams moving on from Customer.io, Mailchimp, Iterable
              and similar tools.
            </h2>
            <p className="mt-2 max-w-md text-sm text-neutral-500 md:text-base">
              We handle the hard part — so your team can focus on growth, not
              operations.
            </p>
          </div>
        </div>

        <div className="flex flex-wrap items-start justify-center gap-x-4 gap-y-6 md:gap-x-6">
          {COMPETITORS.map((competitor) => (
            <CompetitorLogo key={competitor.name} {...competitor} />
          ))}
        </div>
      </div>
    </div>
  );
}
